import { create } from 'zustand';
import apiClient from '../utils/apiClient';

export const useUsersStore = create((set, get) => ({
  users: [],
  isLoading: false,
  error: null,
  lastFetched: 0,
  cacheDuration: 5 * 60 * 1000, // 5 minutes

  fetchUsers: async () => {
    const now = Date.now();
    const { lastFetched, cacheDuration } = get();
    if (now - lastFetched < cacheDuration) {
      return; // Use cached users
    }
    set({ isLoading: true, error: null });
    try {
      const response = await apiClient.get('/user-list');
      set({
        users: Array.isArray(response) ? response : [],
        isLoading: false,
        lastFetched: now,
        error: null
      });
    } catch (error) {
      set({ users: [], isLoading: false, error: error.message || 'Failed to fetch users' });
    }
  },

  getUserById: (id) => {
    const { users } = get();
    return users.find(user => user.id === id) || null;
  },

  clearUsers: () => {
    set({ users: [], lastFetched: 0, error: null });
  },

  updateUser: async (userId, updateData) => {
    try {
      const updatedUser = await apiClient.put(`/user/${userId}`, updateData);
      set(state => ({
        users: state.users.map(u => u.id === userId ? updatedUser : u)
      }));
      console.log('[usersStore] user updated:', updatedUser);
      return updatedUser;
    } catch (error) {
      console.error("[usersStore] Failed to update user:", error);
      throw error;
    }
  },

  deleteUser: async (userId) => {
    try {
      await apiClient.delete(`/user/${userId}`);
      set(state => ({
        users: state.users.filter(u => u.id !== userId)
      }));
      console.log('[usersStore] user deleted:', userId);
    } catch (error) {
      console.error('[usersStore] Failed to delete user:', error);
      throw error;
    }
  },

  addUser: async (userData) => {
    try {
      const newUser = await apiClient.post("/user", userData);
      set(state => ({
        users: [...state.users, newUser]
      }));
      console.log('[usersStore] user added:', newUser);
      return newUser;
    } catch (error) {
      console.error('[usersStore] Failed to add user:', error);
      throw error;
    }
  },

  resetTotp: async (userId) => {
    try {
      const response = await apiClient.post('/user-request', {
        action: 'reset-totp',
        user_id: userId,
      });
      set(state => ({
        users: state.users.map(u =>
          u.id === userId ? { ...u, is_mfa_enabled: false, totp_secret: null } : u
        ),
      }));
      console.log('[usersStore] TOTP reset for', userId, response);
      return response;
    } catch (error) {
      console.error('[usersStore] Failed to reset TOTP:', error);
      throw error;
    }
  },
}));
